import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";
class ZoneTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}

  render() {
    const { depots } = this.props;
    return (
      <Table responsive striped>
        <thead>
          <tr>
            <th>Customer</th>
            {/* <th>External ID</th> */}
            <th>Name</th>
            <th>Description</th>
            <th>Address</th>

            <th>Status</th>

            {/* <th>MapOverlay</th> */}
            <th>Updated</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {depots.map((depot, index) => {
            return (
              <tr key={index}>
                <a
                  onClick={() =>
                    localStorage.setItem(
                      "customer",
                      JSON.stringify({
                        customerId: depot.customerId,
                        customerName: depot.customerName,
                      })
                    )
                  }
                  href={`/zones?customerId=${depot.customerId}&customerName=${depot.customerName}`}
                >
                  <td>{depot.customerName}</td>
                </a>

                {/* <td></td> */}
                <td>{depot.name}</td>
                <td>{depot.description}</td>
                <td>{depot.address}</td>
                <td>{depot.status == 1 ? "Active" : "Disabled"}</td>

                {/* <td className="width-adjust">{depot.overlay}</td> */}
                <td>{utcToLocal(depot.dbUpdated)}</td>

                <td>
                  <Link to={`/editZone/${depot.id}`}>Edit</Link> |{" "}
                  <Link to={`/zoneDetails/${depot.id}`}>Details</Link> |{" "}
                  <Link to={`/deleteZone/${depot.id}`}>Delete</Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default ZoneTable;
